import { getDefaultDraft } from '../../onboarding/lib/defaults'
import { readOnboardingMode } from '../../onboarding/lib/entry'
import type { OrganizationSummary } from './types'

export function buildLocalOrganizationSummary(): OrganizationSummary {
  const draft = getDefaultDraft()
  const onboardingMode = readOnboardingMode() ?? 'guided'

  return {
    id: 'local-organization',
    name: draft.company.companyName,
    slug: 'local-draft',
    industry: draft.company.industry,
    employeeRange: draft.company.employeeRange || null,
    city: draft.company.city || null,
    postalCode: draft.company.postalCode || null,
    websiteUrl: draft.company.websiteUrl,
    visionStatement: draft.vision.visionStatement,
    goals: draft.vision.goals,
    markenkern: draft.strategy.markenkern || null,
    positioning: draft.strategy.positioning || null,
    mission: draft.strategy.mission || null,
    usp: draft.strategy.usp || null,
    primaryOffer: draft.strategy.primaryOffer || null,
    strategicGoals: draft.strategy.strategicGoals,
    proofPoints: draft.strategy.proofPoints,
    audienceSummary: draft.audience.audienceSummary,
    decisionMakers: draft.audience.decisionMakers,
    triggerContext: draft.audience.triggerContext,
    tone: {
      formality: draft.tone.formality,
      emotionality: draft.tone.emotionality,
      technicality: draft.tone.technicality,
      assertiveness: draft.tone.assertiveness,
      verbosity: draft.tone.verbosity,
    },
    tabooWords: draft.tone.blockedWords
      ? draft.tone.blockedWords.split(',').map((w) => w.trim()).filter(Boolean)
      : [],
    preferredPhrases: draft.tone.preferredPhrases
      ? draft.tone.preferredPhrases.split(',').map((w) => w.trim()).filter(Boolean)
      : [],
    onboardingCompletedSteps: [],
    onboardingCompletedAt: null,
    onboardingMode,
    channelLinkedinConnected: false,
    linkedinPageName: '',
    channelInstagramConnected: false,
    instagramHandle: '',
    channelNewsletterConnected: false,
    newsletterSenderEmail: '',
    newsletterAudienceSource: 'Bestandskundenliste',
    source: 'local',
  }
}